import { KEYS } from 'app/constants/SceneConstants';
import SceneBaseTT from './SceneBaseTT';

export default class StoryComplete extends SceneBaseTT {
  constructor() {
    super({ key: KEYS.StoryComplete, active: false });
  }

  create() {
    super.create();
    this.setBackgroundImage('background_purple');
    this.add.image(840, 175, 'locale_text', 'title_gamecomplete');
    this.add.spine(840, 500, 'intro_end', 'end', true, true);
    this.add.image(840, 620, 'graphics', 'panel_game_complete');
    this.add.image(840, 620, 'locale_text', 'copy_tobecontinued');
    this.game.hud.setState('BASIC_HOME');
    this.game.soundController.playMusic('game_complete');
  }

  handleStartGame() {
    this.game.showIntro();
  }

  shutdown() {
    super.shutdown();
  }
}
